import styled from 'styled-components'

export const EditToastMessageWrapper = styled.div`
  margin-bottom: 1.8rem;
`
